<template>
  <crud-editor
    ref="editor"
    :definition="definition"
    :is-edit="false"
    :auto-generated-id="false"
    :save="saveData"
    :return-to="returnTo"
    :item-type="entity"
    :get-layout="layout"
    :get-route-on-save="getRouteOnSave"
  />
</template>

<script>
import CrudEditor from '@/components/crud/TabbedEditor';
import formMixin from './form-mixin';
import { getCreateLayoutDefinition } from './form.js';

export default {
  components: {
    CrudEditor
  },
  mixins: [formMixin],
  data() {
    return {
      layout: getCreateLayoutDefinition
    };
  },
  methods: {
    getRouteOnSave(item) {
      return {
        name: 'Edit' + this.entity,
        params: {
          id: item.id
        },
        query: {
          matrixYN: item.matrixYN
        }
      };
    },
    saveData(form) {
      form.domainID = +this.$route.params.domainID;
      const item = this.createItemFromFormData(this, form);
      return this.$store.dispatch(this.entityStore + '/persistItem', item);
    }
  }
};
</script>
